module.exports = __webpack_public_path__ + "assets/685d757f5667df4b13a905acaedbe9b6.mp3";


/*****************
 ** WEBPACK FOOTER
 ** /Users/kevinduarte/SG/roc2/engine/public-src/spingames/panel/sounds/buttons/menu.mp3
 ** module id = 27
 ** module chunks = 0
 **/